/* ----------------------------------------------------------------------------
| Copyright (c) Jupyter Development Team.
| Distributed under the terms of the Modified BSD License.
|----------------------------------------------------------------------------*/
import { DataConnector } from '@jupyterlab/statedb';
import { Token } from '@lumino/coreutils';
import { requestTranslationsAPI } from './server';
/**
 * Application default locale.
 */
export const DEFAULT_LANGUAGE_CODE = 'en';
/**
 * A service to connect to the server translation endpoint
 */
export const ITranslatorConnector = new Token('@jupyterlab/translation:ITranslatorConnector', 'A service to connect to the server translation endpoint.');
export class TranslatorConnector extends DataConnector {
    constructor(translationsUrl = '', serverSettings) {
        super();
        this._translationsUrl = translationsUrl;
        this._serverSettings = serverSettings;
    }
    async fetch(opts) {
        var _a;
        return requestTranslationsAPI(this._translationsUrl, (_a = opts === null || opts === void 0 ? void 0 : opts.language) !== null && _a !== void 0 ? _a : '', {}, this._serverSettings);
    }
}
/**
 * Translation provider token
 */
export const ITranslator = new Token('@jupyterlab/translation:ITranslator', 'A service to translate strings.');
//# sourceMappingURL=tokens.js.map